import { api } from '@/lib/api';
import type { SourceCoverage } from '@waypoint/shared';

export interface MetricDelta {
  metricId: string;
  label: string;
  current: number;
  previous: number;
  delta: number;
  deltaPct: number;
  direction: 'up' | 'down' | 'flat';
  isBetter: boolean;
}

export interface WeeklyDigestResult {
  weekLabel: string;
  highlights: string[];
  concerns: string[];
  /** Only the deltas whose source is connected and synced; `coverage` says what the rest would need. */
  metricDeltas: MetricDelta[];
  coverage?: SourceCoverage;
}

export async function getWeeklyDigest(): Promise<WeeklyDigestResult> {
  return api('/v1/weekly-digest');
}
